// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/arrow-down.js';

import { paths } from '../generated/arrow-down';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('arrow-down', Original, paths);
